import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { Cliente } from './Cliente';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Vertical } from '../Verticales/Vertical';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IClienteNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface IClienteNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    errors: any[];
    verticales: any[];
    openErroDialog: boolean;
}

export default class ClienteNew extends React.Component<IClienteNewProps, IClienteNewState> {
    _cliente: Cliente = new Cliente();
    
    public constructor(props: IClienteNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            errors: [],
            verticales: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetVerticales();
    }

    componentWillReceiveProps(nextProps: Readonly<IClienteNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open && this.state.errors.length == 0} fullWidth>
                    <DialogTitle>
                        Nuevo cliente
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth variant="standard" style={{marginBottom: '20px'}}>
                                <InputLabel id="labelVerticales">Vertical</InputLabel>
                                <Select label="Vertical" labelId='labelVerticales' onChange={(event: SelectChangeEvent) => {
                                    this._cliente.verticalId = Number(event.target.value);
                                }}>
                                    {
                                        this.state.verticales.map((value: Vertical, index: number) => {
                                            return (
                                                <MenuItem value={value.id}>
                                                    {
                                                        value.name
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Razón social' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._cliente.razonSocial = event.target.value;
                                    }
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' label='CIF' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.cif = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' label='Dirección' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.direccion = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' label='Código postal' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.codigoPostal = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' label='Localidad' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.localidad = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' label='Provincia' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.provincia = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField variant='standard' label='País' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.pais = event.target.value;
                                }}/>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField type='number' variant='standard' label='Barbecho por defecto (en días)' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this._cliente.defaultFallow = Number(event.target.value);
                                }}/>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.errors.length > 0} fullWidth>
                    <DialogTitle>
                        Error
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>
                            Se ha producido el siguiente error al guardar los datos:
                        </Typography>
                        <div className='errors'>
                            <List>
                                {
                                    this.state.errors.map((value: string, index: number) => {
                                        return (
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CancelOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={value} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    errors: []
                                }
                            );
                        }}>Ok</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if(this._cliente.razonSocial == '' || this._cliente.razonSocial == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        if(this._cliente.verticalId == 0) {
            this._cliente.verticalId = undefined;
        }

        let url = `${Common.END_POINT}/clientes`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._cliente),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._cliente = new Cliente();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true,
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._cliente = new Cliente();
        });
    }

    private GetVerticales() {
        let url = `${Common.END_POINT}/masters/Verticales`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    verticales: response
                }
            );
        })
    }
}